import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: '',
  // 超时
  timeout: 10000
})
// request拦截器
service.interceptors.request.use(config => {
  // // get请求映射params参数
  // if (config.method === 'get' && config.params) {
  //   let url = config.url + '?';
  //   for (const propName of Object.keys(config.params)) {
  //     const value = config.params[propName];
  //     var part = encodeURIComponent(propName) + "=";
  //     if (value !== null && typeof(value) !== "undefined") {
  //       if (typeof value === 'object') {
  //         for (const key of Object.keys(value)) {
  //           if (value[key] !== null && typeof (value[key]) !== 'undefined') {
  //             let params = propName + '[' + key + ']';
  //             let subPart = encodeURIComponent(params) + '=';
  //             url += subPart + encodeURIComponent(value[key]) + '&';
  //           }
  //         }
  //       } else {
  //         url += part + encodeURIComponent(value) + "&";
  //       }
  //     }
  //   }
  //   url = url.slice(0, -1);
  //   config.params = {};
  //   config.url = url;
  // }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  return res.data
}
)

const defHttpCatch = (vueInstance, err) => {
  // Helio: 适配业务失败文案返回、入参校验失败文案返回字段名
  let msg = '与服务器连接不畅，请稍后再试或联系客服'
  console.log('defHttpCatch.err', err)
  const response = err.response
  if (response.data) {
    if (response.data.data) {
      if (response.data.data.message) {
        msg = response.data.data.message
      }
    } else {
      if (response.data.msg) {
        msg = response.data.msg
      }
    }
  }
  vueInstance.$message.error(msg)
}
export {defHttpCatch}

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js